module.exports = __webpack_public_path__ + "img/icon_won_blue.3d2c73eb.svg";